import { createContext, useContext } from "react";
import { Trans } from "@wix/wix-i18n-config";
const TranslationContext = createContext(
  void 0
);
function useTranslation() {
  const context = useContext(TranslationContext);
  if (context === void 0) {
    throw new Error("useTranslation must be used within a TranslationProvider");
  }
  return context;
}
export {
  Trans,
  TranslationContext,
  useTranslation
};
//# sourceMappingURL=translation-context.js.map
